import { ResendDigitalSignatureRequestClientRequest } from '../../../@types/resendDigitalSignature'
import { useDigitalSignatureSettingsStore } from '../../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useAgent } from '../../../Stores/useAgent'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useSendDigitalSignatureStore } from '../../../Stores/useSendDigitalSignatureStore'

export const useResendDigitalSignaturePayload = () => {
  const { agentIdBySessionStorage } = useAgent()
  const { createProposal } = useCreateProposalStore()
  const { settings } = useDigitalSignatureSettingsStore()

  const { sendDigitalSignature } = useSendDigitalSignatureStore()

  const payload: ResendDigitalSignatureRequestClientRequest = {
    signatureId: sendDigitalSignature?.digitalSignature?.signatureId || '',
    participantId: settings?.participants?.[0]?.participantId || '', // TODO: Check this value
    mediationAccount: agentIdBySessionStorage || '',
    policyId: createProposal?.createProposalResponse?.proposalId || '',
  }

  return payload
}
